import PropTypes from 'prop-types'
import React from 'react'

export const AddBtn = ({isVisible}) =>
  isVisible
    ? <div className='dz-message'>
      <a href='javascript:void(0)'> Izaberi fotografije </a>
      <span>ili prevuci ovdje</span>
    </div>
    : null

AddBtn.propTypes = {
  isVisible: PropTypes.bool.isRequired
}

AddBtn.defaultProps = {
  isVisible: false
}
